export default function normalizeRoomName(roomName) {
  const roomMappings = {
    black: 'Black Room',
    white: 'White Room',
    gold: 'Gold Room',
  };

  const normalizedRoomName = roomName.toLowerCase();

  for (const [key, value] of Object.entries(roomMappings)) {
    if (normalizedRoomName.includes(key)) {
      return value;
    }
  }

  return roomName;
}
